import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const BaseSaveViewActionButton = ({
  disabled,
  onClick,
  tooltip,
  use,
  'data-test-id': dataTestId,
  tooltipProps,
  children
}) => {
  return /*#__PURE__*/_jsx(IconButton, {
    disabled: disabled,
    onClick: onClick,
    tooltip: tooltip,
    use: use,
    "data-test-id": dataTestId,
    size: "sm",
    tooltipProps: tooltipProps,
    marginInlineStart: "100",
    children: children
  });
};